// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"483":"5798548d","657":"f0672ee1"}[chunkId] + ".chunk.css";
};